/**
 * Возращаем месяц в формате MM
 *
 * @param {Date} date - дата
 * @returns {string} - месяц
 */
export function getFullMouth(date) {
    const currentDate = new Date(date.getTime());
    return `${('0' + (currentDate.getMonth() + 1)).slice(-2)}`;
}

/**
 * Возращаем число в формате DD
 *
 * @param {Date} date - дата
 * @returns {string} - число
 */
export function getFullDate(date) {
    const currentDate = new Date(date.getTime());
    return `${('0' + currentDate.getDate()).slice(-2)}`;
}

/**
 * Возращаем день недели
 *
 * @param {Date} date - дата
 * @returns {string} - день недели
 */
export function getFullDay(date) {
    const currentDate = new Date(date.getTime());
    const daysName = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
    return daysName[currentDate.getDay()];
}

/**
 * Возращаем время в формате hh:mm
 *
 * @param {Date} date - дата
 * @returns {string} - строка со временем
 */
export function dateToScheduleFormat(date) {
    const currentDate = new Date(date.getTime());
    return currentDate.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1').slice(0, -3);
}

/**
 * Генерируем строку с датой в формате YYYY-MM-DD для запроса к API
 *
 * @param {Date} date - дата
 * @returns {string} - строка с датой
 */
export function dateToServerFormat(date) {
    const currentDate = new Date(date.getTime());
    return `${currentDate.getFullYear()}-${getFullMouth(currentDate)}-${getFullDate(currentDate)}`;
}

/**
 * Генерируем строку со временем в формате hh:mm для запроса к API
 *
 * @param {object} time - временной интервал
 * @returns {string} - строка со временем
 */
export function timeToServerFormat(time) {
    const hours = `${('0' + time.hour).slice(-2)}`;
    const minute = `${('0' + time.minute).slice(-2)}`;

    return `${hours}:${minute}`;
}

/**
 * Создаем массив с датами на неделю
 *
 * @returns {array} - массив с датами
 */
export function createDateList() {
    const dateList = [];
    const specialDaysName = ['Вчера', 'Сегодня', 'Завтра'];

    for (let i = -2; i < 5; i++) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + i);

        let tabTitle = `${getFullDay(currentDate)}, ${getFullDate(currentDate)}`;
        if (i >= -1 && i <= 1) {
        tabTitle = specialDaysName[i + 1];
    }
        dateList.push({ start: currentDate, tabTitle });
    }

    return dateList;
}

/**
 * Приводим дату в ISO-формат
 *
 * @param {string} currentDate - дата
 * @returns {Date}
 */
export function createDate(currentDate) {
    return new Date(currentDate.replace(' ', 'T'));
}

/**
 * Добавляем объекты даты в каждую трансляцию
 *
 * @param {object} schedule - объект с трансляциями
 * @returns {object} - объект с расписанием
 */
export function addTimeToSchedule(schedule) {
    const tempSchedule = { ...schedule };

    Object.keys(tempSchedule).forEach((channel) => {
        tempSchedule[channel].forEach((broadcast) => {
            const duration = parseInt(broadcast.duration, 10);
            const start = createDate(broadcast.start);
            const finish = createDate(broadcast.start);
            finish.setSeconds(finish.getSeconds() + duration);

            broadcast.duration = duration;
            broadcast.finish = finish;
            broadcast.start = start;
            broadcast.status = null;
        });
    });

    return tempSchedule;
}

/**
 * Создаем временные интервалы для
 * фильтра по времени суток
 *
 * @returns {object} - объект с временными интервалами
*/
export function createTimeIntevals() {
    return {
        morning: {
            start: { hour: 0, minute: 0 },
            finish: { hour: 11, minute: 59 },
        },
        afternoon: {
            start: { hour: 12, minute: 0 },
            finish: { hour: 15, minute: 59 },
        },
        evening: {
            start: { hour: 16, minute: 0 },
            finish: { hour: 23, minute: 59 },
        },
    };
}

/**
 * Получаем временной интервал
 * соответствующий текущему времени
 *
 * @returns {string} - название текущего временного интервала
*/
export function getCurrentTimeInterval() {
    const nowDate = new Date();
    const timeIntervals = createTimeIntevals();

    return Object.keys(timeIntervals)
        .filter(interval => {
            const hour = nowDate.getHours();
            const { start, finish } = timeIntervals[interval];

            return (hour >= start.hour) && (hour <= finish.hour);
        })[0];
}

/**
 *
 * Сортировка каналов по времени
 *
 * @param {object} broadcasts - обьект программы
 * @returns {object} - сортированные обьекты программы
*/
export function broadcastsFilter(broadcasts) {
    const nowDate = new Date();
    const pastBroadcasts = [];
    let futureBroadcasts = [];

    broadcasts.every((broadcast, index) => {
        if (Date.parse(broadcast.start) <= nowDate.getTime()) {
            broadcast.status = false;
            pastBroadcasts.push(broadcast);
            return true;
        } else {
            futureBroadcasts = broadcasts.slice(index, broadcasts.length - 1);
            return false;
        }
    });

    if (pastBroadcasts.length > 0) {
        const lastBroadcast = pastBroadcasts[pastBroadcasts.length - 1];

        if (nowDate >= lastBroadcast.start.getTime() && nowDate < lastBroadcast.finish.getTime()) {
            lastBroadcast.status = true;
            lastBroadcast.progress = ((nowDate.getTime() - lastBroadcast.start) / (lastBroadcast.duration * 1000) * 100).toFixed(2);
            futureBroadcasts.unshift(pastBroadcasts.pop());
        }
    }

    return {
        futureBroadcasts,
        pastBroadcasts,
    };
}
